import { Link } from 'react-router-dom';

const setWorkspace = (workspace: 'demo' | 'logo') => {
  localStorage.setItem('activeWorkspace', workspace);
};

const CARD_STYLES = {
  demo:
    'from-sky-50 via-white to-blue-50 border-sky-200 hover:border-sky-300 hover:shadow-sky-100/80',
  logo:
    'from-amber-50 via-white to-orange-50 border-amber-200 hover:border-amber-300 hover:shadow-amber-100/80',
};

const LandingPage: React.FC = () => {
  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="rounded-[40px] border border-slate-200/80 bg-white/85 p-8 shadow-xl shadow-slate-200/50 backdrop-blur md:p-12">
        <p className="text-xs font-semibold uppercase tracking-[0.32em] text-slate-400">Workspace</p>
        <h1 className="mt-4 max-w-3xl text-4xl font-semibold tracking-tight text-slate-950 md:text-5xl">
          Choose the catalog you want to search.
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600">
          Use demos to browse live implementations and sales assets. Use logos to browse Coveo customer logos prepared
          for slides, snippets, references, and presentation-ready storytelling.
        </p>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          <Link
            to="/demos/search"
            onClick={() => setWorkspace('demo')}
            className={`group rounded-[32px] border bg-gradient-to-br p-7 shadow-lg transition duration-200 ${CARD_STYLES.demo}`}
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-3xl bg-sky-600 text-white shadow-lg shadow-sky-200">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11H5m14 0a2 2 0 100-4H5a2 2 0 000 4m14 0v6a2 2 0 01-2 2H7a2 2 0 01-2-2v-6m14 0H5"
                />
              </svg>
            </div>
            <h2 className="mt-6 text-2xl font-semibold text-slate-950">Demo Search</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Search demo records, owners, industries, personas, and implementation metadata.
            </p>
            <div className="mt-8 inline-flex items-center text-sm font-semibold text-sky-700">
              Open demos
              <span className="ml-2 transition group-hover:translate-x-0.5">→</span>
            </div>
          </Link>

          <Link
            to="/logos/search"
            onClick={() => setWorkspace('logo')}
            className={`group rounded-[32px] border bg-gradient-to-br p-7 shadow-lg transition duration-200 ${CARD_STYLES.logo}`}
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-3xl bg-amber-500 text-white shadow-lg shadow-amber-200">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 7h16M4 12h16M4 17h10"
                />
              </svg>
            </div>
            <h2 className="mt-6 text-2xl font-semibold text-slate-950">Logo Search</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Browse Coveo customer logos, filter by business context, and prepare polished assets for slides,
              snippets, and references.
            </p>
            <div className="mt-8 inline-flex items-center text-sm font-semibold text-amber-700">
              Open logos
              <span className="ml-2 transition group-hover:translate-x-0.5">→</span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
